import { AbstractEntityService } from "./AbstractEntityService";

export class PriceModifierService extends AbstractEntityService {
    constructor(baseUrl) {
        super();
        this.baseUrl = baseUrl;
    }

    collectionUrl(propertyId) {
        return `${this.baseUrl}/properties/${propertyId}/priceModifiers`;
    }

    /**
     * @param {string} propertyId
     * @param {{ roomId?: string|number, planId?: string|number, adjustmentScope?: string }} [options]
     */
    async findAll(propertyId, options = {}) {
        const { roomId, planId, adjustmentScope } = options;
        let url = this.collectionUrl(propertyId);
        const params = new URLSearchParams();
        if (roomId != null && roomId !== "") {
            params.append("roomId", roomId);
        }
        if (planId != null && planId !== "") {
            params.append("planId", planId);
        }
        if (adjustmentScope != null && adjustmentScope !== "") {
            params.append("adjustmentScope", adjustmentScope);
        }
        const qs = params.toString();
        if (qs) {
            url += `?${qs}`;
        }

        try {
            return await super.find(url);
        } catch (error) {
            this.handleError(error, "Unable to load the list of price modifiers - please see server logs for more details");
        }
    }

    async create(propertyId, priceModifier) {
        const url = this.collectionUrl(propertyId);

        try {
            return await super.create(url, priceModifier);
        } catch (error) {
            this.handleError(error, "Unable to create a price modifier - please see server logs for more details");
        }
    }

    async update(propertyId, priceModifier) {
        const url = `${this.collectionUrl(propertyId)}/${priceModifier.id}`;

        try {
            return await super.update(url, priceModifier);
        } catch (error) {
            this.handleError(error, `Unable to update a price modifier - please see server logs for more details`);
        }
    }

    async delete(propertyId, id) {
        const url = `${this.collectionUrl(propertyId)}/${id}`;

        try {
            return await super.delete(url);
        } catch (error) {
            this.handleError(error, `Unable to delete a price modifier - please see server logs for more details`);
        }
    }
}
